import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    CatalogosGeneralesServiceProxy,
    CausaInclusionProgramaResponse,
    CausaInclusionProgramaGetListQuery
} from '../../../../shared/service-proxies/service-proxies';


@Component({
    templateUrl: 'busquedacausasinclusionprograma-grid.component.html',
    styleUrls: ['../../../../assets/css-custom/p-datatable-general.scss']
})
export class BusquedaCausasInclusionProgramaGridComponent extends AppComponentBase implements OnInit {

    form: FormGroup;

    data: CausaInclusionProgramaResponse[];
    pagedTableSummary: PagedTableSummary = new PagedTableSummary();

    cols: any[];
    selectedItem: any;
    query: CausaInclusionProgramaGetListQuery = new CausaInclusionProgramaGetListQuery();

    blockedDocument = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private service: CatalogosGeneralesServiceProxy

    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        self.cols = [
            { field: 'id', header: this.l('Busquedas.CausasInclusionPrograma.Id'), isActive: true },
            { field: 'descripcion', header: this.l('Busquedas.CausasInclusionPrograma.Descripcion'), isActive: true },
        ];

        self.form = self.formBuilder.group({
            filterText: [null]
        });

        self.query = new CausaInclusionProgramaGetListQuery();
        self.query.pageNumber = 1;
        self.query.pageSize = 10;
        self.getList();
    }


    getList(): void {
        const self = this;

        self.query.filter = self.f.filterText.value;
        self.blockedDocument = true;

        self.service.getCausasInclusionProgramaList(self.query)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.data = data.items;

                // Calculate paged table summary
                self.pagedTableSummary = self.getPagedTableSummay(data.totalCount, self.query.pageNumber, self.query.pageSize);
            });
    }

    loadData(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.query.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.query.sorting = '';
        }

        self.query.pageNumber = 1 + (event.first / event.rows);
        self.query.pageSize = event.rows;

        self.getList();
    }

    filterSearch($event): void {
        const self = this;

        $event.preventDefault();

        self.query.pageNumber = 1;
        self.query.pageSize = 10;
        self.getList();
    }

    seleccionar(rowData: CausaInclusionProgramaResponse): void {
        const self = this;
        console.log(rowData);
        self.close(rowData);
    }


    close(seleccionado: CausaInclusionProgramaResponse): void {
        const self = this;

        self.modalRef.close(seleccionado);
    }
}
